const appName = "Code Solving";
export { appName };
